import { render, staticRenderFns } from "./NotesPage.vue?vue&type=template&id=c9cb3428&scoped=true&"
import script from "./NotesPage.vue?vue&type=script&lang=js&"
export * from "./NotesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cb3428",
  null
  
)

export default component.exports